export const storeId = "storeId";
export const userToken = "userToken";
export const userRefreshToken = "userRefreshToken";
// Chart palette aligned to colors_v2.css design tokens (light mode):
//   [0] Invoices / net sales     = future-tax-future-tax-90 (#324664)
//   [1] Credit Notes             = warning-warning-80        (#fab732)
//   [2] Effective / positive     = success-success-140       (#12833c)
export const eColors = ["#324664", "#fab732", "#12833c"];
export const countriesCords = [
  {
    name: "Russia",
    id: "RU",
    code: "RU",
    lat: 54.10064,
    lon: 43.242188,
  },
  {
    name: "Germany",
    id: "DE",
    code: "DE",
    lat: 50.94,
    lon: 10.19,
  },
  {
    name: "United Kingdom",
    id: "GB",
    code: "GB",
    lat: 52.1,
    lon: -1.23,
  },
  {
    name: "France",
    id: "FR",
    code: "FR",
    lat: 46.35,
    lon: 2.29,
  },
  {
    name: "Italy",
    id: "IT",
    code: "IT",
    lat: 43.12,
    lon: 12.12,
  },
  {
    name: "Spain",
    id: "ES",
    code: "ES",
    lat: 40.03,
    lon: -3.49,
  },
  {
    name: "Ukraine",
    id: "UA",
    code: "UA",
    lat: 49.2,
    lon: 32.79,
  },
  {
    name: "Poland",
    id: "PL",
    code: "PL",
    lat: 51.95,
    lon: 19.89,
  },
  {
    name: "Romania",
    id: "RO",
    code: "RO",
    lat: 45.89,
    lon: 24.59,
  },
  {
    name: "Netherlands",
    id: "NL",
    code: "NL",
    lat: 51.82,
    lon: 4.64,
  },
  {
    name: "Belgium",
    id: "BE",
    code: "BE",
    lat: 50.73,
    lon: 4.58,
  },
  {
    name: "Czech Republic (Czechia)",
    id: "CZ",
    code: "CZ",
    lat: 49.75,
    lon: 14.71,
  },
  {
    name: "Greece",
    id: "GR",
    code: "GR",
    lat: 39.58,
    lon: 21.62,
  },
  {
    name: "Portugal",
    id: "PT",
    code: "PT",
    lat: 40.29,
    lon: -8.07,
  },
  {
    name: "Sweden",
    id: "SE",
    code: "SE",
    lat: 64.49,
    lon: 17.65,
  },
  {
    name: "Hungary",
    id: "HU",
    code: "HU",
    lat: 47.11,
    lon: 19.05,
  },
  {
    name: "Belarus",
    id: "BY",
    code: "BY",
    lat: 53.22,
    lon: 27.71,
  },
  {
    name: "Austria",
    id: "AT",
    code: "AT",
    lat: 47.7,
    lon: 14.67,
  },
  {
    name: "Serbia",
    id: "RS",
    code: "RS",
    lat: 44.17,
    lon: 20.75,
  },
  {
    name: "Switzerland",
    id: "CH",
    code: "CH",
    lat: 46.82,
    lon: 8.22,
  },
  {
    name: "Bulgaria",
    id: "BG",
    code: "BG",
    lat: 42.73,
    lon: 25.44,
  },
  {
    name: "Denmark",
    id: "DK",
    code: "DK",
    lat: 56.38,
    lon: 9.43,
  },
  {
    name: "Finland",
    id: "FI",
    code: "FI",
    lat: 62.52,
    lon: 25.87,
  },
  {
    name: "Slovakia",
    id: "SK",
    code: "SK",
    lat: 48.73,
    lon: 19.11,
  },
  {
    name: "Norway",
    id: "NO",
    code: "NO",
    lat: 60.87,
    lon: 8.99,
  },
  {
    name: "Ireland",
    id: "IE",
    code: "IE",
    lat: 53.16,
    lon: -7.83,
  },
  {
    name: "Croatia",
    id: "HR",
    code: "HR",
    lat: 45.09,
    lon: 14.01,
  },
  {
    name: "Moldova",
    id: "MD",
    code: "MD",
    lat: 47.48,
    lon: 28.32,
  },
  {
    name: "Bosnia and Herzegovina",
    id: "BA",
    code: "BA",
    lat: 44.14,
    lon: 17.61,
  },
  {
    name: "Albania",
    id: "AL",
    code: "AL",
    lat: 40.73,
    lon: 19.68,
  },
  {
    name: "Lithuania",
    id: "LT",
    code: "LT",
    lat: 55.18,
    lon: 24.37,
  },
  {
    name: "Macedonia",
    id: "MK",
    code: "MK",
    lat: 41.62,
    lon: 21.69,
  },
  {
    name: "Slovenia",
    id: "SI",
    code: "SI",
    lat: 45.99,
    lon: 14.52,
  },
  {
    name: "Latvia",
    id: "LV",
    code: "LV",
    lat: 56.83,
    lon: 26.08,
  },
  {
    name: "Estonia",
    id: "EE",
    code: "EE",
    lat: 58.595272,
    lon: 25.013607,
  },
  {
    name: "Montenegro",
    id: "ME",
    code: "ME",
    lat: 42.44,
    lon: 18.92,
  },
  {
    name: "Luxembourg",
    id: "LU",
    code: "LU",
    lat: 49.75,
    lon: 6.12,
  },
  {
    name: "Malta",
    id: "MT",
    code: "MT",
    lat: 35.9,
    lon: 14.44,
  },
  {
    name: "Iceland",
    id: "IS",
    code: "IS",
    lat: 64.84,
    lon: -17.48,
  },
  {
    name: "Andorra",
    id: "AD",
    code: "AD",
    lat: 42.52,
    lon: 1.58,
  },
  {
    name: "Monaco",
    id: "MC",
    code: "MC",
    lat: 43.73,
    lon: 7.4,
  },
  {
    name: "Liechtenstein",
    id: "LI",
    code: "LI",
    lat: 47.16,
    lon: 9.56,
  },
  {
    name: "San Marino",
    id: "SM",
    code: "SM",
    lat: 43.95,
    lon: 12.45,
  },
];
